import React from "react";
import { Modal, Image, Button } from "react-bootstrap";
import SalirIcon from "../../../../Images/salir.svg";
import './ModalUnrecognized.css';

export const ModalUnrecognized = (props) => {
  return (
    <Modal id="unrecognized_modal" size="lg" show={props.show} aria-labelledby="example-modal-sizes-title-sm">
      <Modal.Header style={{flexDirection: 'column', borderBottom: '0px'}}>
          <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'} }>
          <Image
            src={SalirIcon}
            onClick={props.hideModal}
            alt="X"
            style={{ cursor: "pointer" }}
          />
          </div>
          <div style={{width: '100%', display: 'flex', justifyContent: 'center'} }>
              <Modal.Title className="title-settings">
              {props.traductions.Card.enabled.modalUnrecognized.title}
              </Modal.Title>
          </div>
      </Modal.Header>
      <Modal.Body>
        <div style={{ textAlign: "center" }}>
          <span className="text-call-number">
          {props.traductions.Card.enabled.modalUnrecognized.L_body}
          </span>
        </div>
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <span className="phone-number-blue">+52 81 9034 9039</span>
        </div>
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <Button onClick={props.hideModal} className="ghost-cancelar">
          {props.traductions.Card.enabled.modalUnrecognized.L_cancel}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
